export const LocalPlaceListType = {
  MOTEL: 'motel',
  AROUND: 'around',
  HOTEL: 'hotel',
  GUESTHOUSE: 'guest-house',
  PENSION: 'pension',
  TOPAD: 'top-adver',
} as const;

export const LocalPageName = {
  /** 서브홈 - 모텔 PLP */
  MOTEL: 'MOTEL',
  /** 서브홈 - 호텔 PLP */
  HOTEL: 'HOTEL',
  /** 서브홈 - 펜션 PLP */
  PENSION: 'PENSION',
  /** 서브홈 - 게스트하우스 PLP */
  GUESTHOUSE: 'GUESTHOUSE',
  /** 내주변 PLP */
  AROUND: 'AROUND',
  /** SRP */
  KEYWORD: 'KEYWORD',
} as const;

export const ListNameForLog = {
  [LocalPageName.MOTEL]: 'Motel', // 모텔
  [LocalPageName.HOTEL]: 'Hotel', // 호텔
  [LocalPageName.PENSION]: 'Pension', // 펜션
  [LocalPageName.GUESTHOUSE]: 'GuestHouse', // 게스트하우스
  [LocalPageName.AROUND]: 'Around', // 내주변
  [LocalPageName.KEYWORD]: 'SearchResult', // 검색결과
} as const;

export const PlaceShortCut = {
  /** 모텔 서브홈 - 야놀자 초이스 */
  TOP: 'top',
  /** 모텔 서브홈 - 선착순 쿠폰 (내주변PLP) */
  RECOMMEND_MOTEL: 'recommendMotel',
  /** 전체 */
  ALL: 'all',
  /** 선착순 쿠폰 */
  RECOMMEND: 'recommend',
  /** 모텔 */
  MOTEL: 'motel',
  /** 호텔 */
  HOTEL: 'hotel',
  /** 펜션 */
  PENSION: 'pension',
  /** 게스트하우스 */
  GUESTHOUSE: 'guestHouse',
  /** #부티크브랜드 */
  BOUTIQUE: 'boutique',
  /** #프리미엄펜션 */
  PREMIUM_PENSION: 'premiumPension',
  /** #신축/리모델링 */
  CONSTRUCT: 'construct',
  /** #추천리조트 */
  RESORT: 'resort',
  /** #오션뷰호텔 */
  OCEAN_VIEW_HOTEL: 'oceanViewHotel',
  /** #조식제공 (호텔PLP) */
  BREAKFAST_HOTEL: 'breakfastHotel',
  /** #조식제공 (게스트하우스PLP) */
  BREAKFAST_GUESTHOUSE: 'breakfastGuestHouse',
  /** #수영장호텔 */
  POOL_HOTEL: 'poolHotel',
  /** #초특가호텔 */
  HOT_DEAL: 'hotDeal',
  /** #파티룸 */
  PARTY_ROOM: 'partyRoom',
  /** #풀빌라 */
  POOL_VILLA: 'poolVilla',
  /** #스파펜션 */
  SPA_PENSION: 'spaPension',
  /** #독채펜션 */
  ISOLATE_PENSION: 'isolatePension',
  /** #개별바베큐 */
  BARBECUE_PENSION: 'barbecuePension',
  /** #한옥 */
  HANOK: 'hanok',
  /** #투어/체험 */
  TOUR_GUESTHOUSE: 'tourGuestHouse',
  /** #커플룸 */
  COUPLE_GUESTHOUSE: 'coupleGuestHouse',
  /** #파티가능 */
  PARTY_GUESTHOUSE: 'partyGuestHouse',
} as const;

export const CATEGORY_METADATA = {
  [LocalPageName.MOTEL]: {
    title: '모텔 리스트 | NOL',
    description: '모텔 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords: 'NOL, 모텔, 모텔예약, 모텔할인, 대실, 대실할인, 무한대실,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.HOTEL]: {
    title: '호텔 리스트 | NOL',
    description: '호텔, 리조트 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords: 'NOL, 호텔/리조트, 숙소예약, 호텔찾기, 모텔찾기, 모텔놀수록 놀라운 혜택!,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.PENSION]: {
    title: '펜션 리스트 | NOL',
    description: '펜션, 풀빌라 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords: 'NOL, 펜션/풀빌라, 독채펜션, 펜션수영장, 가족펜션, 커플펜션, 놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.GUESTHOUSE]: {
    title: '게스트하우스 리스트 | NOL',
    description: '게스트하우스 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords:
      'NOL, 게스트하우스, 게하, 게스트하우스 추천, 게스트하우스 예약, 게스트하우스 후기,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.KEYWORD]: {
    title: '{keyword} 국내숙소 검색 결과 | NOL',
    description:
      '{keyword} 모텔, 호텔, 펜션, 풀빌라, 게스트하우스 숙소 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords:
      'NOL, 모텔, 호텔, 펜션, 게스트하우스, 캠핑, 글램핑, 풀빌라, 레지던스, 호캉스, 대실, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천,놀, nol, 야놀자, yanolja',
  },
} as const;

export const AROUND_METADATA = {
  [PlaceShortCut.MOTEL]: {
    title: '내 주변 국내숙소 리스트 | NOL',
    description: '가까운 호텔, 숙소를 빠르게 찾아보세요. 다양한 사진, 후기, 최저가 비교, 간편 예약',
    tagKeywords: 'NOL, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천',
  },
  [PlaceShortCut.HOTEL]: {
    title: '내 주변 국내숙소 리스트 | NOL',
    description: '가까운 호텔, 숙소를 빠르게 찾아보세요. 다양한 사진, 후기, 최저가 비교, 간편 예약',
    tagKeywords: 'NOL, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천',
  },
  [PlaceShortCut.PENSION]: {
    title: '내 주변 국내숙소 리스트 | NOL',
    description: '가까운 호텔, 숙소를 빠르게 찾아보세요. 다양한 사진, 후기, 최저가 비교, 간편 예약',
    tagKeywords: 'NOL, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천',
  },
  [PlaceShortCut.GUESTHOUSE]: {
    title: '내 주변 국내숙소 리스트 | NOL',
    description: '가까운 호텔, 숙소를 빠르게 찾아보세요. 다양한 사진, 후기, 최저가 비교, 간편 예약',
    tagKeywords: 'NOL, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천',
  },
} as const;

export const SHORTCUT_METADATA = {
  [LocalPageName.MOTEL]: {
    title: '{location} {shortcut} 리스트 | NOL',
    description:
      '{location} 모텔 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords: 'NOL, 모텔, 모텔예약, 모텔할인, 대실, 대실할인, 무한대실,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.HOTEL]: {
    title: '{location} {shortcut} 리스트 | NOL',
    description:
      '{location} 호텔, 리조트 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords:
      'NOL, 호텔/리조트, {location}호텔/리조트, 숙소예약, 호텔찾기, 모텔찾기, 모텔놀수록 놀라운 혜택!,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.PENSION]: {
    title: '{location} {shortcut} 리스트 | NOL',
    description:
      '{location} 펜션, 풀빌라 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords:
      'NOL, 펜션/풀빌라, {location}펜션/풀빌라, 독채펜션, 펜션수영장, 가족펜션, 커플펜션,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.GUESTHOUSE]: {
    title: '{location} {shortcut} 리스트 | NOL',
    description:
      '{location} 게스트하우스 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
    tagKeywords:
      'NOL, 게스트하우스, {location}게스트하우스, {location}게하, 게스트하우스 추천, 게스트하우스 예약, 게스트하우스 후기,놀, nol, 야놀자, yanolja',
  },
  [LocalPageName.AROUND]: {
    title: '내 주변 국내숙소 리스트 | NOL',
    description: '가까운 호텔, 숙소를 빠르게 찾아보세요. 다양한 사진, 후기, 최저가 비교, 간편 예약',
    tagKeywords: 'NOL, 주변모텔, 주변호텔, 숙소할인, 빈방찾기, 호텔추천, 모텔추천',
  },
} as const;

export const NOL_CHOICE_METADATA = {
  title: '{location} 국내숙소 리스트 | NOL',
  description: '{location} 모텔 추천 | 다양한 사진, 후기, 최저가를 비교하고 원하는 숙소를 찾아 편리하게 예약해보세요.',
  tagKeywords:
    '모텔, 모텔예약, 모텔할인, 대실, 대실할인, 무한대실, 놀아보고서, 좋은숙박, 혼자, 배낭, 둘이, 연인, 가족, 여행, 드라이브, 추천, 인기, 놀수록 놀라운 혜택!, 저렴, 쿠폰,놀, nol, 야놀자, yanolja',
};

export type PlaceShortCutValue = (typeof PlaceShortCut)[keyof typeof PlaceShortCut];
export type LocalPlaceListTypeValue = (typeof LocalPlaceListType)[keyof typeof LocalPlaceListType];
export type LocalPageNameValue = (typeof LocalPageName)[keyof typeof LocalPageName];

export const COOKIE_KEY_CHECK_IN_OUT_DOMESTIC = 'cinout-domestic' as const;
export const COOKIE_KEY_CAPACITY_DOMESTIC = 'capacity-domestic' as const;

export const cookieKey = {
  LOCATION: 'location',
};

export const DEFAULT_COOKIE_OPTIONS = {
  maxAge: 60 * 60 * 24 * 30, // 30일
  domain: '.yanolja.com',
};

export const FILTER_LABEL = '필터';
export const SORT_LABEL = '정렬';
